module.exports = __webpack_public_path__ + "static/img/浦发银行.52d5768.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/浦发银行.jpg
// module id = QtBn
// module chunks = 1